import moment from 'moment';
import { SET_CONFIG } from '../constants/config';

const initialState = {
  lastConfigCheckDateTime: null,
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONFIG: {
      return { ...action.config, lastConfigCheckDateTime: moment().format('YYYY-MM-DD HH:mm:ss') };
    }
    default:
      return state;
  }
};

export default config;
